import React, { useState, useContext, useEffect, useRef, useCallback } from "react";
import LoadingSpinnerImage from "../Shared/LoadingSpinnerImage.js";
import { useDropzone } from 'react-dropzone';
import "./App.css";
import CountryRegistrationsDocuments from "../CountryRegistrationsDocuments/CountryRegistrationsDocuments.js";

const SubmissionAttachments = ({ submissionId, users, globalContext }) => {

    const [attachments, setAttachments] = useState([]);
    const [isLoadingData, setIsLoadingData] = useState(false);
    const [isUploadedData, setIsUploadedData] = useState(null);
    const [showUnlinkAttachmentPopup, setShowUnlinkAttachmentPopup] = useState(false);
    const [showMoveAttachmentPopup, setShowMoveAttachmentPopup] = useState(false);
    const [unlinkFileId, setUnlinkFileId] = useState(false);
    const [moveFileId, setMoveFileId] = useState(false);
    const [isMovingFile, setIsMovingFile] = useState(false);
    const [allSubmissionFilesIds, setAllSubmissionFilesIds] = useState([]);
    const [searchResults, setSearchResults] = useState([{}, {}, {}]);
    const [showEditGroupPopup, setShowEditGroupPopup] = useState(false);
    const [showCreateGroupPopup, setShowCreateGroupPopup] = useState(false);
    const [defaultObjectListSortByField, setDefaultObjectListSortByField] = useState("CreatedOn");
    const [defaultObjectListSortByType, setDefaultObjectListSortByType] = useState("ASCENDING");
    const [whereAmI, setWhereAmI] = useState("All References");
    const [isLoadingFolders, setIsLoadingFolders] = useState(false);
    const [groups, setGroups] = useState([]);
    const [isFoldersContextMenuVisible, setIsFoldersContextMenuVisible] = useState(false);
    const [selectedParentGroupId, setSelectedParentGroupId] = useState(null);
    const [isEditingGroupId, setIsEditingGroupId] = useState(false);
    const [selectedMainMenuOption, setSelectedMainMenuOption] = useState("all");
    const [currentGroupId, setCurrentGroupId] = useState(null);
    const [userRole, setUserRole] = useState(window.userRole);
    const [selectedParentGroupIdFromContextMenu, setSelectedParentGroupIdFromContextMenu] = useState(null);
    const [showSearchExistingFilesPopup, setShowSearchExistingFilesPopup] = useState(false);
    const [showCreateStructureFromTemplatePopup, setShowCreateStructureFromTemplatePopup] = useState(false);
    const [showUploadFilesPopup, setshowUploadFilesPopup] = useState(false);
    const [allFilesCount, setAllFilesCount] = useState(null);
    const [docType, setDocType] = useState(null);
    const [showMaxFilesError, setShowMaxFilesError] = useState(false);
    const [fileUploadResults, setFileUploadResults] = useState([]);
    const [isCreatingStructureFromTemplate, setIsCreatingStructureFromTemplate] = useState(false);
    const [selectedTemplate, setSelectedTemplate] = useState("");
    const [errorCreatingStructureFromTemplate, setErrorCreatingStructureFromTemplate] = useState(null);

    const folderContextMenuRef = useRef(null);
    const folderContextMenuIconRefs = useRef({});
    const currentGroupIdRefForFileUpload = useRef(null);
    const maxFiles = 10;
    const [openDropdownId, setOpenDropdownId] = useState(null);

    const toggleDropdown = (id) => {
        if (openDropdownId === id) {
            setOpenDropdownId(null);
        } else {
            setOpenDropdownId(id);
        }
    };


    // Just to update currentGroupId for uploads
    useEffect(() => { currentGroupIdRefForFileUpload.current = currentGroupId; }, [currentGroupId]);


    const onDrop = useCallback((acceptedFiles) => {

        setIsUploadedData(false);

        let localGroupId = currentGroupIdRefForFileUpload.current;

        let linkFileUrl = "/umbraco/api/Submission/Files/?submissionId=" + submissionId + "&folderId=" + localGroupId;

        const formData = new FormData();

        setShowMaxFilesError(false);

        if (acceptedFiles.length > maxFiles) {
            setIsUploadedData(null);
            setShowMaxFilesError(true);
            return;
        }

        // Max 10 files
        const limitedFiles = acceptedFiles.slice(0, maxFiles);

        limitedFiles.forEach(file => formData.append('files', file));

        let requestOptions = {
            method: 'POST',
            body: formData,
        };

        setIsLoadingData(true);

        fetch(linkFileUrl, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {
                if (result) {

                    setFileUploadResults(result);

                    loadAttachments({ localGroupId });

                    let howManyFilesUploaded = result.filter(file => file.Imported == true).length;

                    updateCountOnFolder(localGroupId, howManyFilesUploaded);

                    setAllFilesCount(prev => prev + howManyFilesUploaded);

                }
            })
            .catch((error) => {
                console.log(error);
                setIsLoadingData(false);
                setIsUploadedData(false)
            })
            .finally(() => {
                setIsUploadedData(true)
            });

    }, []);


    useEffect(() => {

        loadFolders();
        loadAllFilesCount();
        loadAttachments();

    }, []);





    const loadAllFilesCount = () => {

        let foldersUrl = "/umbraco/api/Submission/AllFiles/?submissionId=" + submissionId;

        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };

        fetch(foldersUrl, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                if (data) {

                    setAllFilesCount(data);

                }
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
            });
    }


    const loadFolders = () => {

        let foldersUrl = "/umbraco/api/Submission/Folders/?submissionId=" + submissionId;

        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };


        setIsLoadingFolders(true);


        fetch(foldersUrl, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                if (data) {

                    data = data.map(item => {
                        if (!item.Count)
                            item.Count = 0;
                        return item;
                    });

                    setGroups(data);

                }
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                setIsLoadingFolders(false);
            });
    }


    const loadAttachments = ({
        localGroupId = null,
    } = {}) => {

        let attachmentsUrl = "/umbraco/api/Submission/Files/?submissionId=" + submissionId + "&folderId=" + localGroupId;

        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };

        // updates current GroupId for next calls (next page for example)
        setCurrentGroupId(localGroupId);

        setIsLoadingData(true);

        fetch(attachmentsUrl, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                // Update state with the received data
                if (data) {
                    setAttachments(data);

                    // Requested all files, fill in the ids to compare with the file search to show link button or not
                    if (localGroupId == null) {
                        setAllSubmissionFilesIds(data.map(file => file.FileKey));
                    }

                }
            })
            .catch((error) => {
            })
            .finally(() => {
                setIsLoadingData(false);
            });
    }


    const unlinkAttachment = () => {

        let fileId = unlinkFileId;
        let attachmentsUrl = "/umbraco/api/Submission/Files/?submissionId=" + submissionId + "&submissionFileId=" + fileId;
        let originalGroupId = attachments.find(item => item.CertificateFileId == fileId).FolderId;

        const requestOptions = {
            method: "DELETE",
            headers: { "Content-Type": "application/json" },
        };

        setIsLoadingData(true);

        fetch(attachmentsUrl, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.text();
            })
            .then((data) => {

                // Close popup
                setShowUnlinkAttachmentPopup(false);

                // Update state with the received data
                setAttachments(prev => prev.filter(item => item.CertificateFileId != fileId));

                // Update count on folders
                updateCountOnFolder(originalGroupId, -1);

                // Update All Files count
                setAllFilesCount(prev => prev - 1);
            })
            .catch((error) => {
            })
            .finally(() => {
                setIsLoadingData(false);
            });
    }


    const moveAttachment = () => {

        let fileId = moveFileId;
        let originalGroupId = attachments.find(item => item.CertificateFileId == fileId).FolderId;
        let newGroupId = selectedParentGroupId;


        let attachmentsUrl = "/umbraco/api/Submission/Files/?submissionId=" + submissionId + "&submissionFileId=" + fileId + "&folderId=" + newGroupId;

        const requestOptions = {
            method: "PATCH",
            headers: { "Content-Type": "application/json" },
        };


        setIsMovingFile(true);

        fetch(attachmentsUrl, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.text();
            })
            .then((data) => {

                // Remove file from current list
                setAttachments(prev => prev.filter(item => item.CertificateFileId != fileId));

                // Close popup
                setShowMoveAttachmentPopup(false);

                // Update count on folders
                updateCountOnFolder(originalGroupId, -1);
                updateCountOnFolder(newGroupId, 1);
            })
            .catch((error) => {
            })
            .finally(() => {
                setIsMovingFile(false);
            });

    }


    const showDeletePopup = (fileId) => {

        setUnlinkFileId(fileId);
        setShowUnlinkAttachmentPopup(true);

    }


    const showMovePopup = (fileId) => {

        let fileGroupId = attachments.find(item => item.CertificateFileId == fileId).FolderId;

        setSelectedParentGroupId(fileGroupId);
        setMoveFileId(fileId);
        setShowMoveAttachmentPopup(true);

    }


    const formatDate = (dateStr, includeTime = false) => {
        const dateObj = new Date(dateStr);
        const year = dateObj.getFullYear();
        const month = String(dateObj.getMonth() + 1).padStart(2, "0"); // Month is zero-indexed
        const day = String(dateObj.getDate()).padStart(2, "0");

        let time = "";
        if (includeTime) {
            let hours = (dateObj.getHours() < 10 ? '0' : '') + dateObj.getHours();
            let minutes = (dateObj.getMinutes() < 10 ? '0' : '') + dateObj.getMinutes();

            time = ` ${hours}:${minutes}`;
        }

        const formattedDate = `${year}-${month}-${day}${time}`;
        return formattedDate;
    };


    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept:
        {
            'image/*': [],
            'application/pdf': [], // PDF
            'application/msword': [], // .doc
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [], // .docx
            'application/vnd.ms-excel': [], // .xls
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [], // .xlsx
            'application/vnd.ms-powerpoint': [], // .ppt
            'application/vnd.openxmlformats-officedocument.presentationml.presentation': [] // .pptx
        },
        multiple: true,
    });


    const drawGroupsDropdown = ({ ignoreIds = [], value = selectedParentGroupId, onChangeFunc = setSelectedParentGroupId, defaultOptionText = "All Files" } = {}) => {

        return (
            <select value={value} onChange={(e) => { onChangeFunc(e.target.value); }} >
                <option value="null">{defaultOptionText}</option>
                {drawGroupsDropdownOptions(null, 0, ignoreIds)}
            </select>

        );

    }


    const drawGroupsDropdownOptions = (parent, level, ignoreIds) => {

        const drawName = (groupName) => {

            let name = "";

            for (let i = 0; i < level; i++)
                name += "\u00A0\u00A0\u00A0\u00A0";


            //if(level > 0)
            //    name += "> ";

            name += groupName;

            return name;

        }

        if (ignoreIds == null)
            ignoreIds = [];

        let childGroups = groups.filter(group => !ignoreIds.find(g => g == group.Id)).filter(group => group.ParentId == parent).sort((a, b) => a.Name.localeCompare(b.Name, undefined, { sensitivity: 'base' }));

        if (childGroups.length == 0)
            return;

        return (
            childGroups.map((group, index) => {

                return (<React.Fragment key={index}><option value={group.Id}>{drawName(group.Name)}</option>{drawGroupsDropdownOptions(group.Id, level + 1, ignoreIds)}</React.Fragment>);

            })

        );

    }


    const closeGroupRelatedPopups = () => {

        setShowCreateGroupPopup(false);
        setShowEditGroupPopup(false);

    }


    const navigateTo = ({ menu, groupId = null }) => {

        if (isLoadingData)
            return;


        let defaultFilters = {

            localGroupId: null,
            localSortBy: defaultObjectListSortByField,
            localSortType: defaultObjectListSortByType,
            localTrash: false,
            localRecent: false,
            localFavorites: false,
            localDuplicates: false,
        }

        let whereAmILabel = "";

        setSelectedMainMenuOption(menu);

        if (menu == "all") {
            whereAmILabel = "All References";
        }


        if (menu == "recentlyadded") {
            whereAmILabel = "Recently Added (last 30 days)";
            defaultFilters = { ...defaultFilters, localSortBy: "CreatedOn" };
            defaultFilters = { ...defaultFilters, localSortType: "DESCENDING" };
            defaultFilters = { ...defaultFilters, localRecent: true };
        }


        if (menu == "trash") {
            whereAmILabel = "Trash";
            defaultFilters = { ...defaultFilters, localTrash: true };
            defaultFilters = { ...defaultFilters, localSortBy: "UpdatedOn" };
            defaultFilters = { ...defaultFilters, localSortType: "DESCENDING" };
        }


        if (menu == "favorites") {
            whereAmILabel = "Favorites";
            defaultFilters = { ...defaultFilters, localFavorites: true };
            defaultFilters = { ...defaultFilters, localTrash: false };
            defaultFilters = { ...defaultFilters, localSortBy: "UpdatedOn" };
            defaultFilters = { ...defaultFilters, localSortType: "DESCENDING" };
        }

        if (menu == "duplicates") {
            whereAmILabel = "Duplicates";
            defaultFilters = { ...defaultFilters, localDuplicates: true };
            defaultFilters = { ...defaultFilters, localSortBy: "" }; // it will order by mbri by default to group duplicates
            defaultFilters = { ...defaultFilters, localSortType: "DESCENDING" };
        }


        if (menu == "group") {

            if (groupId != null) {
                let groupName = groups.find((i) => i.Id == groupId).Name;
                whereAmILabel = "Folder: " + groupName;
            }

            defaultFilters = { ...defaultFilters, localGroupId: groupId };
        }

        let res = loadAttachments(defaultFilters);

        if (res != false)
            setWhereAmI(whereAmILabel);

    }


    /* method to link external files to submission */
    const callBackFromCountryRegistrationsDocuments = (fileId) => {

        return new Promise((resolve, reject) => {

            let linkFileUrl = "/umbraco/api/Submission/Files/?submissionId=" + submissionId + "&folderId=" + currentGroupId + "&certificateFileId=" + fileId;

            const requestOptions = {
                method: "POST",
                headers: { "Content-Type": "application/json" },
            };

            fetch(linkFileUrl, requestOptions)
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 401)
                            document.dispatchEvent(new Event("api:unauthorized"));

                        throw new Error("Network response was not ok");
                    }
                    return response.text();
                })
                .then((data) => {

                    loadAttachments({ localGroupId: currentGroupId });

                    // Update count on folders
                    updateCountOnFolder(currentGroupId, 1);

                    // Update All Files count
                    setAllFilesCount(prev => prev + 1);

                    resolve(true);
                })
                .catch((error) => {
                    console.log(error);
                    resolve(false);
                })
                .finally(() => {
                    setIsLoadingData(false);
                });


        });

    }

    // Updates only on folders not for "All Files" option
    const updateCountOnFolder = (folderId, add) => {

        if (folderId == null)
            return;

        setGroups(prev => prev.map(item => {
            if (item.Id != folderId)
                return item;

            if (!item.Count)
                item.Count = 0;

            item.Count += add;

            if (item.Count < 0)
                item.Count = 0;

            return item;
        }));

    }




    const clickHandler = () => {

        setIsFoldersContextMenuVisible(false);
    }



    const downloadFile = () => {



    }



    const showUploadNewFilesPopup = () => {

        setIsUploadedData(null);
        setShowMaxFilesError(false);
        setshowUploadFilesPopup(true);

    }
    const iconMap = {
        pdf: 'fas fa-file-pdf text-danger',
        doc: 'fas fa-file-word text-primary',
        docx: 'fas fa-file-word text-primary',
        xls: 'fas fa-file-excel text-success',
        xlsx: 'fas fa-file-excel text-success',
        ppt: 'fas fa-file-powerpoint text-warning',
        pptx: 'fas fa-file-powerpoint text-warning',
        png: 'fas fa-file-image text-info',
        jpg: 'fas fa-file-image text-info',
        jpeg: 'fas fa-file-image text-info',
        tiff: 'fas fa-file-image text-info',
        tif: 'fas fa-file-image text-info',
        ris: 'fas fa-file-alt text-info',
        txt: 'fas fa-file-alt text-info',
        csv: 'fas fa-file-alt text-success'
    };

    const getFileIcon = (filename) => {
        const ext = filename?.split('.').pop().toLowerCase();
        return iconMap[ext] || 'fas fa-file text-secondary';
    };



    const createStructureFromTemplate = () => {

        if (selectedTemplate === "")
            return;

        let structure = {};
        if (selectedTemplate === "STED") {
            structure = {
                name: "STED (GHTF)",
                children: [
                    {
                        name: "1.0 Device Description and Product Specification",
                        children: [
                            { name: "Device Description", children: [] },
                            { name: "Product Specification", children: [] },
                            { name: "Reference to similar and previous generations of the device", children: [] }
                        ]
                    },
                    {
                        name: "2.0 Information Supplied by the Manufacturer",
                        children: [
                            { name: "Labels", children: [] },
                            { name: "Instructions for Use", children: [] }
                        ]
                    },
                    {
                        name: "3.0 Design and Manufacturing Information",
                        children: [
                            { name: "Device Design", children: [] },
                            { name: "Manufacturing Processes", children: [] }
                        ]
                    },
                    {
                        name: "4.0 Essential Principles (EP) Checklist",
                        children: []
                    },
                    {
                        name: "5.0 Risk Analysis and Control Summary",
                        children: []
                    },
                    {
                        name: "6.0 Product Verification and Validation",
                        children: [
                            { name: "Biocompatibility", children: [] },
                            { name: "Medicinal Substances", children: [] },
                            { name: "Biological Safety", children: [] },
                            { name: "Sterilization", children: [] },
                            { name: "Software Verification and Validation", children: [] },
                            { name: "Animal Studies", children: [] },
                            { name: "Clinical Evidence", children: [] },
                            { name: "Electromagnetic Compatibility (EMC) and Electrical Safety", children: [] },
                            { name: "Shelf Life, Stability, and Packaging", children: [] }
                        ]
                    }
                ]
            };
        }

        if (selectedTemplate === "IMDRF") {
            structure = {
                name: "nIVD ToC (IMDRF)",
                children: [
                    {
                        name: "CHAPTER 1 – REGIONAL ADMINISTRATIVE",
                        children: [
                            { name: "1.01 Cover Letter", children: [] },
                            { name: "1.02 Submission Table of Contents", children: [] },
                            { name: "1.03 List of Terms/Acronyms", children: [] },
                            { name: "1.04 Application Form/Administrative Information", children: [] },
                            { name: "1.05 Listing of Device(s)", children: [] },
                            { name: "1.06 Quality Management System, Full Quality System or Other Regulatory Certificates", children: [] },
                            { name: "1.07 Free Sale Certificate/ Certificate of Marketing authorization", children: [] },
                            { name: "1.08 Expedited Review Documentation", children: [] },
                            { name: "1.09 User Fees", children: [] },
                            { name: "1.10 Pre-Submission Correspondence and Previous Regulator Interactions", children: [] },
                            { name: "1.11 Acceptance for Review Checklist", children: [] },
                            {
                                name: "1.12 Statements/Certifications/Declarations of Conformity",
                                children: [
                                    { name: "1.12.01 Performance and Voluntary Standard", children: [] },
                                    { name: "1.12.02 Environmental Assessment", children: [] },
                                    { name: "1.12.03 Clinical Trial Certifications", children: [] },
                                    { name: "1.12.04 Indications for Use Statement with Rx and/or OTC designation Enclosure", children: [] },
                                    { name: "1.12.05 Truthful and Accurate Statement", children: [] },
                                    { name: "1.12.06 USFDA Class III Summary and Certification", children: [] },
                                    { name: "1.12.07 Declaration of Conformity", children: [] }
                                ]
                            },
                            { name: "1.13 Letters of Reference", children: [] },
                            { name: "1.14 Letter of Authorization", children: [] },
                            { name: "1.15 Other Regional Administrative Information", children: [] }
                        ]
                    },
                    {
                        name: "CHAPTER 2 – SUBMISSION CONTEXT",
                        children: [
                            { name: "2.01 Chapter Table of Contents", children: [] },
                            { name: "2.02 General Summary of Submission", children: [] },
                            { name: "2.03 Summary and Certifications for Regulatory Submissions", children: [] },
                            {
                                name: "2.04 Device Description",
                                children: [
                                    { name: "2.04.01 Comprehensive Device Description and Principle of Operation", children: [] },
                                    { name: "2.04.02 Description of Device Packaging", children: [] },
                                    { name: "2.04.03 History of Development", children: [] },
                                    { name: "2.04.04 Reference and Comparison to Similar and/or Previous Generations of the Device", children: [] },
                                    { name: "2.04.05 Substantial Equivalence Discussion", children: [] }
                                ]
                            },
                            {
                                name: "2.05 Indications for Use and/or Intended Use and Contraindications",
                                children: [
                                    { name: "2.05.01 Intended Use; Intended Purpose; Intended User; Indications for Use", children: [] },
                                    { name: "2.05.02 Intended Environment/Setting for use", children: [] },
                                    { name: "2.05.03 Pediatric Use", children: [] },
                                    { name: "2.05.04 Contraindications For Use", children: [] }
                                ]
                            },
                            {
                                name: "2.06 Global Market History",
                                children: [
                                    { name: "2.06.01 Global Market History", children: [] },
                                    { name: "2.06.02 Incident Reports and Recalls", children: [] },
                                    { name: "2.06.03 Sales, Incident and Recall Rates", children: [] },
                                    { name: "2.06.04 Evaluation/Inspection Reports", children: [] }
                                ]
                            },
                            { name: "2.07 Post-Market Study Plans", children: [] },
                            { name: "2.08 Risk Management", children: [] },
                            { name: "2.09 Essential Principles (EP) Checklist", children: [] },
                            {
                                name: "2.10 Standards",
                                children: [
                                    { name: "2.10.01 List of Standards and Guidance Documents", children: [] },
                                    { name: "2.10.02 Declaration and/or Certification of Conformity", children: [] }
                                ]
                            },
                            { name: "2.11 Other Submission Context Information", children: [] }
                        ]
                    },
                    {
                        name: "CHAPTER 3 – NON-CLINICAL EVIDENCE",
                        children: [
                            { name: "3.01 Chapter Table of Contents", children: [] },
                            { name: "3.02 Chapter Retired", children: [] },
                            { name: "3.03 Chapter Retired", children: [] },
                            { name: "3.04 Chapter Retired", children: [] },
                            {
                                name: "3.05 Non-clinical Studies",
                                children: [
                                    {
                                        name: "3.05.01 Physical and Mechanical Characterization",
                                        children: [
                                            {
                                                name: "3.05.01.01 [Study description, study identifier, date of initiation]",
                                                children: [
                                                    { name: "3.05.01.01.01 Summary", children: [] },
                                                    { name: "3.05.01.01.02 Full Report", children: [] },
                                                    { name: "3.05.01.01.03 Statistical Data", children: [] }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        name: "3.05.02 Chemical/Material Characterization",
                                        children: [
                                            {
                                                name: "3.05.02.01 [Study description, study identifier, date of initiation]",
                                                children: [
                                                    { name: "3.05.02.01.01 Summary", children: [] },
                                                    { name: "3.05.02.01.02 Full Report", children: [] },
                                                    { name: "3.05.02.01.03 Statistical Data", children: [] }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        name: "3.05.03 Electrical Systems: Safety, Mechanical and Environmental Protection, and Electromagnetic Compatibility",
                                        children: [
                                            {
                                                name: "3.05.03.01 [Study description, study identifier, date of initiation]",
                                                children: [
                                                    { name: "3.05.03.01.01 Summary", children: [] },
                                                    { name: "3.05.03.01.02 Full Report", children: [] },
                                                    { name: "3.05.03.01.03 Statistical Data", children: [] }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        name: "3.05.04 Radiation Safety",
                                        children: [
                                            {
                                                name: "3.05.04.01 [Study description, study identifier, date of initiation]",
                                                children: [
                                                    { name: "3.05.04.01.01 Summary", children: [] },
                                                    { name: "3.05.04.01.02 Full Report", children: [] },
                                                    { name: "3.05.04.01.03 Statistical Data", children: [] }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        name: "3.05.05 Software/Firmware/Programmed or programmable medical devices",
                                        children: [
                                            { name: "3.05.05.01 Software/Firmware Description", children: [] },
                                            { name: "3.05.05.02 Risk Management File (including Hazard Analysis)", children: [] },
                                            { name: "3.05.05.03 Software Requirement Specification (SRS)", children: [] },
                                            { name: "3.05.05.04 System and Software Architecture Design (SAD) Chart", children: [] },
                                            { name: "3.05.05.05 Software Design Specification (SDS)", children: [] },
                                            { name: "3.05.05.06 Traceability Analysis", children: [] },
                                            { name: "3.05.05.07 Software Life Cycle Process Description / Software Development, Configuration Management, and Maintenance Practices", children: [] },
                                            { name: "3.05.05.08 Software Testing as Part of Verification and Validation", children: [] },
                                            { name: "3.05.05.09 Software Version / Revision Level History", children: [] },
                                            { name: "3.05.05.10 Unresolved Software Anomalies", children: [] },
                                            { name: "3.05.05.11 Cybersecurity", children: [] },
                                            { name: "3.05.05.12 Interoperability", children: [] }
                                        ]
                                    },
                                    {
                                        name: "3.05.06 Biocompatibility and Toxicology Evaluation",
                                        children: [
                                            {
                                                name: "3.05.06.01 [Study description, study identifier, date of initiation]",
                                                children: [
                                                    { name: "3.05.06.01.01 Summary", children: [] },
                                                    { name: "3.05.06.01.02 Full Report", children: [] },
                                                    { name: "3.05.06.01.03 Statistical Data", children: [] }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        name: "3.05.07 Non-Material-Mediated Pyrogenicity",
                                        children: [
                                            {
                                                name: "3.05.07.01 [Study description, study identifier, date of initiation]",
                                                children: [
                                                    { name: "3.05.07.01.01 Summary", children: [] },
                                                    { name: "3.05.07.01.02 Full Report", children: [] },
                                                    { name: "3.05.07.01.03 Statistical Data", children: [] }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        name: "3.05.08 Safety of Materials of Biological Origin (human/animal)",
                                        children: [
                                            { name: "3.05.08.01 Certificates", children: [] },
                                            {
                                                name: "3.05.08.02 [Study description, study identifier, date of initiation]",
                                                children: [
                                                    { name: "3.05.08.02.01 Summary", children: [] },
                                                    { name: "3.05.08.02.02 Full Report", children: [] },
                                                    { name: "3.05.08.02.03 Statistical Data", children: [] }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        name: "3.05.09 Sterilization and Reprocessing Validation",
                                        children: [
                                            {
                                                name: "3.05.09.01 End-User Sterilization",
                                                children: [
                                                    {
                                                        name: "3.05.09.01.01 [Study description, study identifier, date of initiation]",
                                                        children: [
                                                            { name: "3.05.09.01.01.01 Summary", children: [] },
                                                            { name: "3.05.09.01.01.02 Full Report", children: [] },
                                                            { name: "3.05.09.01.01.03 Statistical Data", children: [] }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                name: "3.05.09.02 Manufacturer Sterilization Validation",
                                                children: [
                                                    {
                                                        name: "3.05.09.02.01 [Study description, study identifier, date of initiation]",
                                                        children: [
                                                            { name: "3.05.09.02.01.01 Summary", children: [] },
                                                            { name: "3.05.09.02.01.02 Full Report", children: [] },
                                                            { name: "3.05.09.02.01.03 Statistical Data", children: [] }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                name: "3.05.09.03 Residual Toxicity",
                                                children: [
                                                    {
                                                        name: "3.05.09.03.01 [Study description, study identifier, date of initiation]",
                                                        children: [
                                                            { name: "3.05.09.03.01.01 Summary", children: [] },
                                                            { name: "3.05.09.03.01.02 Full Report", children: [] },
                                                            { name: "3.05.09.03.01.03 Statistical Data", children: [] }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                name: "3.05.09.04 Cleaning and Disinfection Validation",
                                                children: [
                                                    {
                                                        name: "3.05.09.04.01 [Study description, study identifier, date of initiation]",
                                                        children: [
                                                            { name: "3.05.09.04.01.01 Summary", children: [] },
                                                            { name: "3.05.09.04.01.02 Full Report", children: [] },
                                                            { name: "3.05.09.04.01.03 Statistical Data", children: [] }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                name: "3.05.09.05 Reprocessing of Single Use Devices Validation Data",
                                                children: [
                                                    {
                                                        name: "3.05.09.05.01 [Study description, study identifier, date of initiation]",
                                                        children: [
                                                            { name: "3.05.09.05.01.01 Summary", children: [] },
                                                            { name: "3.05.09.05.01.02 Full Report", children: [] },
                                                            { name: "3.05.09.05.01.03 Statistical Data", children: [] }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        name: "3.05.10 Animal Testing",
                                        children: [
                                            {
                                                name: "3.05.10.01 [Study description, study identifier, date of initiation]",
                                                children: [
                                                    { name: "3.05.10.01.01 Summary", children: [] },
                                                    { name: "3.05.10.01.02 Full Report", children: [] },
                                                    { name: "3.05.10.01.03 Statistical Data", children: [] }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        name: "3.05.11 Usability/Human Factors",
                                        children: [
                                            {
                                                name: "3.05.11.01 [Study description, study identifier, date of initiation]",
                                                children: [
                                                    { name: "3.05.11.01.01 Summary", children: [] },
                                                    { name: "3.05.11.01.02 Full Report", children: [] },
                                                    { name: "3.05.11.01.03 Statistical Data", children: [] }
                                                ]
                                            }
                                        ]
                                    },
                                    { name: "3.05.12 Evidence for devices with preservatives or antimicrobial claims", children: [] }
                                ]
                            },
                            { name: "3.06 Non-clinical Bibliography", children: [] },
                            {
                                name: "3.07 Expiration Period and Packaging Validation",
                                children: [
                                    {
                                        name: "3.07.01 Product Stability",
                                        children: [
                                            {
                                                name: "3.07.01.01 [Study description, study identifier, date of initiation]",
                                                children: [
                                                    { name: "3.07.01.01.01 Summary", children: [] },
                                                    { name: "3.07.01.01.02 Full Report", children: [] },
                                                    { name: "3.07.01.01.03 Statistical Data", children: [] }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        name: "3.07.02 Package Validation",
                                        children: [
                                            {
                                                name: "3.07.02.01 [Study description, study identifier, date of initiation]",
                                                children: [
                                                    { name: "3.07.02.01.01 Summary", children: [] },
                                                    { name: "3.07.02.01.02 Full Report", children: [] },
                                                    { name: "3.07.02.01.03 Statistical Data", children: [] }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                name: "3.08 Other non-clinical Evidence",
                                children: [
                                    {
                                        name: "3.08.01 [Study description, study identifier, date of initiation]",
                                        children: [
                                            { name: "3.08.01.01 Summary", children: [] },
                                            { name: "3.08.01.02 Full Report", children: [] },
                                            { name: "3.08.01.03 Statistical Data", children: [] }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        name: "CHAPTER 4 – CLINICAL EVIDENCE",
                        children: [
                            { name: "4.01 Chapter Table of Contents", children: [] },
                            {
                                name: "4.02 Overall Clinical Evidence Summary",
                                children: [
                                    { name: "4.02.01 Clinical Evaluation Report", children: [] },
                                    {
                                        name: "4.02.02 Device Specific Clinical Trials",
                                        children: [
                                            {
                                                name: "4.02.02.01 [Trial description, protocol #, date of initiation]",
                                                children: [
                                                    { name: "4.02.02.01.01 Clinical Trial Summary", children: [] },
                                                    { name: "4.02.02.01.02 Clinical Trial Report", children: [] },
                                                    { name: "4.02.02.01.03 Clinical Trial Data", children: [] }
                                                ]
                                            }
                                        ]
                                    },
                                    { name: "4.02.03 Clinical Literature Review and Other Reasonable Known Information", children: [] }
                                ]
                            },
                            { name: "4.03 Informed Consent Information", children: [] },
                            { name: "4.04 Investigators Sites and IRB Contact Information", children: [] },
                            { name: "4.05 Real World Data (RWD)", children: [] },
                            { name: "4.06 Post-Market Surveillance Data", children: [] },
                            { name: "4.07 Other Clinical Evidence", children: [] }
                        ]
                    },
                    {
                        name: "CHAPTER 5 – LABELLING AND PROMOTIONAL MATERIAL",
                        children: [
                            { name: "5.01 Chapter Table of Contents", children: [] },
                            { name: "5.02 Product/Package Labels", children: [] },
                            { name: "5.03 Package Insert/Instructions for Use", children: [] },
                            { name: "5.04 e-labelling", children: [] },
                            { name: "5.05 Healthcare Professional Labelling", children: [] },
                            { name: "5.06 Patient Labelling", children: [] },
                            { name: "5.07 Technical and/or Operators Manual", children: [] },
                            { name: "5.08 Patient File Stickers/Cards and Implant Registration Cards", children: [] },
                            { name: "5.09 Product Brochures", children: [] },
                            { name: "5.10 Other Labelling and Promotional Material", children: [] }
                        ]
                    },
                    {
                        name: "CHAPTER 6 – QUALITY MANAGEMENT SYSTEM",
                        children: [
                            { name: "6.01 Cover Letter", children: [] },
                            { name: "6.02 Chapter Table of Contents", children: [] },
                            { name: "6.03 Product Descriptive Information", children: [] },
                            { name: "6.04 General Manufacturing Information", children: [] },
                            { name: "6.05 Required Forms", children: [] },
                            { name: "6.06 Quality management system", children: [] },
                            { name: "6.07 Management responsibilities", children: [] },
                            { name: "6.08 Resource management", children: [] },
                            { name: "6.09 Planning of Product Realization and Customer Related Processes", children: [] },
                            { name: "6.10 Design and development", children: [] },
                            { name: "6.11 Purchasing", children: [] },
                            { name: "6.12 Production and service controls", children: [] },
                            { name: "6.13 Control of monitoring and measuring equipment", children: [] },
                            { name: "6.14 QMS measurement, analysis and improvement", children: [] },
                            { name: "6.15 Device Specific Quality Plan", children: [] },
                            { name: "6.16 Quality management system verification document", children: [] },
                            { name: "6.17 Other Quality System Information", children: [] }
                        ]
                    }
                ]
            };
        }
        if (selectedTemplate === "EUMDR") {
            structure = {
                name: "EU MDR Technical Documentation",
                children: [
                    {
                        name: "1. Device Description and Specification",
                        children: [
                            { name: "1.1 Device description and specification (including variants, accessories, classification, materials)", children: [] },
                            { name: "1.2 Reference to previous and similar generations of the device", children: [] }
                        ]
                    },
                    {
                        name: "2. Information to be Supplied by the Manufacturer",
                        children: [
                            { name: "2.1 Declaration of Conformity (DoC)", children: [] },
                            { name: "2.2 Labelling", children: [] },
                            { name: "2.3 Instructions for use / Device Operating Manual(s)", children: [] },
                            { name: "2.4 Electronic IFU (e-IFU) information", children: [] },
                            { name: "2.5 Patient handbook", children: [] },
                            { name: "2.6 Physicians’/other users’ handbook", children: [] },
                            { name: "2.7 Implant card information", children: [] },
                            { name: "2.8 Copies of promotional materials (making specific claims)", children: [] },
                            { name: "2.9 URL of the website (where IFU/labelling is available)", children: [] }
                        ]
                    },
                    {
                        name: "3. Design & Manufacturing Information",
                        children: [
                            { name: "3.1 Design Stages and Information", children: [] },
                            { name: "3.2 Manufacturing Processes", children: [] },
                            { name: "3.3 Sites & Subcontractor Information", children: [] }
                        ]
                    },
                    {
                        name: "4. General Safety & Performance Requirements (GSPRs)",
                        children: [
                            { name: "4.1 GSPR Checklist and Evidence", children: [] }
                        ]
                    },
                    {
                        name: "5. Benefit-Risk Analysis and Risk Management",
                        children: [
                            { name: "5.1 Risk management plan", children: [] },
                            { name: "5.2 Risk analysis / risk control measures", children: [] },
                            { name: "5.4 Risk management report", children: [] }
                        ]
                    },
                    {
                        name: "6. Product Verification and Validation",
                        children: [
                            {
                                name: "6.1 Pre-clinical and Clinical Data",
                                children: [
                                    { name: "6.1.1 Biocompatibility", children: [] },
                                    { name: "6.1.2 Software & Software Validation (Including Cyber Security)", children: [] },
                                    { name: "6.1.3 Electrical Safety and Electromagnetic Compatibility (EMC)", children: [] },
                                    { name: "6.1.4 Packaging, Stability and Shelf-Life", children: [] },
                                    { name: "6.1.5 Performance and Safety - Design Verification and Validations", children: [] },
                                    { name: "6.1.6 Usability", children: [] }
                                ]
                            },
                            {
                                name: "6.2 Specific cases",
                                children: [
                                    { name: "6.2.1 Drug/Device Combination Products", children: [] },
                                    { name: "6.2.2 Human Origin Matter", children: [] },
                                    { name: "6.2.3 Animal Origin Matter", children: [] },
                                    { name: "6.2.4 Biological Origin Matter", children: [] },
                                    { name: "6.2.5 Substances absorbed or locally dispersed", children: [] },
                                    { name: "6.2.6 Hazardous substances, CMR, endocrine disrupting substances", children: [] },
                                    { name: "6.2.7 Sterilisation validation", children: [] }
                                ]
                            },
                            {
                                name: "6.3 Clinical Evaluation",
                                children: [
                                    { name: "6.3.1 Clinical Evaluation Strategy", children: [] },
                                    { name: "6.3.2 Clinical Evaluation Plan (CEP)", children: [] },
                                    { name: "6.3.3 Clinical Evaluation Report (CER)", children: [] },
                                    { name: "6.3.4 Post Market Clinical Follow-Up (PMCF) Plan and Evaluation Report", children: [] },
                                    { name: "6.3.5 Summary of Safety and Clinical Performance (SSCP)", children: [] }
                                ]
                            }
                        ]
                    },
                    {
                        name: "7. Annex III: Post-Market Surveillance",
                        children: [
                            { name: "7.1 Post Market Surveillance Plan", children: [] },
                            { name: "7.2 Periodic Safety Update Report (PSUR) / PMS Report", children: [] }
                        ]
                    }
                ]
            };
        }

        if (selectedTemplate === "510k") {
            structure = {
                name: "FDA 510(k)",
                children: [
                    {
                        name: "Group 1: Administrative Information",
                        children: [
                            { name: "Medical Device User Fee Cover Sheet", children: [] },
                            { name: "CDRH Premarket Review Submission Cover Sheet", children: [] }
                        ]
                    },
                    {
                        name: "Group 2: Public Information",
                        children: [
                            { name: "510(k) Cover Letter", children: [] },
                            { name: "Indications for Use Statement", children: [] },
                            { name: "510(k) Summary OR 510(k) Statement", children: [] }
                        ]
                    },
                    {
                        name: "Group 3: Regulatory Forms and Certifications",
                        children: [
                            { name: "Truthful and Accuracy Statement", children: [] },
                            { name: "Declarations of Conformity", children: [] },
                            { name: "Financial Certification or Disclosure Statement", children: [] }
                        ]
                    },
                    {
                        name: "Group 4: Device and Equivalence",
                        children: [
                            { name: "Executive Summary", children: [] },
                            { name: "Device Description", children: [] },
                            { name: "Substantial Equivalence Discussion", children: [] }
                        ]
                    },
                    {
                        name: "Group 5: Safety and Performance Testing",
                        children: [
                            { name: "Proposed Labeling", children: [] },
                            { name: "Sterilization and Shelf Life", children: [] },
                            { name: "Biocompatibility", children: [] },
                            { name: "Software and Cybersecurity", children: [] },
                            { name: "Electromagnetic Compatibility (EMC) and Electrical Safety", children: [] },
                            { name: "Performance Testing - Bench", children: [] },
                            { name: "Performance Testing - Animal", children: [] },
                            { name: "Performance Testing - Clinical", children: [] }
                        ]
                    }
                ]
            };
        }

        if (selectedTemplate === "CSTD") {
            structure = {
                name: "CSTD (ASEAN)",
                children: [
                    {
                        name: "1. Executive Summary",
                        children: [
                            { name: "Device Overview and Intended Use", children: [] },
                            { name: "Commercial Marketing History", children: [] },
                            { name: "Regulatory Approvals", children: [] },
                            { name: "Important Safety and Performance Information", children: [] },
                            { name: "Declaration of Conformity", children: [] }
                        ]
                    },
                    {
                        name: "2. Relevant Essential Principles and Method of Conformity",
                        children: [
                            { name: "Essential Principles Checklist", children: [] }
                        ]
                    },
                    {
                        name: "3. Device Description",
                        children: [
                            { name: "Physical Description and Principle of Operation", children: [] },
                            { name: "Materials and Dimensions", children: [] },
                            { name: "Accessories and Compatible Devices", children: [] }
                        ]
                    },
                    {
                        name: "4. Summary of Design Verification and Validation Documents",
                        children: [
                            { name: "Pre-clinical and Bench Testing", children: [] },
                            { name: "Biocompatibility", children: [] },
                            { name: "Software Verification and Validation", children: [] },
                            { name: "Animal Studies", children: [] },
                            { name: "Clinical Evidence", children: [] }
                        ]
                    },
                    {
                        name: "5. Device Labeling",
                        children: [
                            { name: "Labels on Device and Packaging", children: [] },
                            { name: "Instructions for Use (IFU)", children: [] }
                        ]
                    },
                    {
                        name: "6. Risk Analysis",
                        children: [
                            { name: "Risk Management File", children: [] }
                        ]
                    },
                    {
                        name: "7. Manufacturer Information",
                        children: [
                            { name: "Company and Site Details", children: [] },
                            { name: "Manufacturing Process Overview", children: [] },
                            { name: "Quality Management System Certificates", children: [] }
                        ]
                    }
                ]
            };
        }
        if (!structure.name)
            return;

        const structureUrl =
            "/umbraco/api/Submission/UseFolderTemplateStructure/?submissionId=" + submissionId;

        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(structure),
        };

        setErrorCreatingStructureFromTemplate(null);
        setIsCreatingStructureFromTemplate(true);

        fetch(structureUrl, requestOptions)
            .then(async (response) => {

                if (!response.ok) {

                    if (response.status === 401) {
                        document.dispatchEvent(new Event("api:unauthorized"));
                    }

                    const errorMessage = await response.text();

                    throw new Error(
                        errorMessage || "The folder structure could not be created."
                    );
                }

                return response.json();
            })
            .then((data) => {

                loadFolders();

                setShowCreateStructureFromTemplatePopup(false);

            })
            .catch((error) => {
                console.log(error);
                setErrorCreatingStructureFromTemplate("This template could not be used. Please contact MedBoard.");
            })
            .finally(() => {
                setIsCreatingStructureFromTemplate(false);
            });
    };




    return (
        <>



            {/* FOLDERS & FILES */}
            {/* FOLDERS & FILES */}

            <div style={{ display: "flex", flexDirection: "row", maxHeight: "100%", minHeight: "100%" }} onClick={clickHandler}>
                <div style={{ width: "30%", paddingRight: "10px", borderRight: "1px solid #dedede", overflowY: "auto" }}>

                    {isLoadingFolders ? <div><LoadingSpinnerImage /></div> :

                        <GroupsMenu
                            groups={groups}
                            setGroups={setGroups}
                            isFoldersContextMenuVisible={isFoldersContextMenuVisible}
                            setIsFoldersContextMenuVisible={setIsFoldersContextMenuVisible}
                            setSelectedParentGroupId={setSelectedParentGroupId}
                            closeGroupRelatedPopups={closeGroupRelatedPopups}
                            setShowCreateGroupPopup={setShowCreateGroupPopup}
                            setIsEditingGroupId={setIsEditingGroupId}
                            setShowEditGroupPopup={setShowEditGroupPopup}
                            selectedMainMenuOption={selectedMainMenuOption}
                            currentGroupId={currentGroupId}
                            navigateTo={navigateTo}
                            userRole={userRole}
                            folderContextMenuIconRefs={folderContextMenuIconRefs}
                            folderContextMenuRef={folderContextMenuRef}
                            allFilesCount={allFilesCount}
                            setAllFilesCount={setAllFilesCount}
                            isMemberGuest={globalContext.isMemberGuest}

                        />

                    }

                </div>
                <div style={{ flex: 1, marginLeft: "10px", overflowY: "auto" }}>


                    <div style={{ display: "flex", flexDirection: "row" }}>

                        <div style={{ textAlign: "left", marginTop: "30px", flex: 1 }}>
                            {(globalContext.userRole === "Admin" && !globalContext.isMemberGuest) && (
                                <>

                                    <span
                                        onClick={() => setShowCreateStructureFromTemplatePopup(true)}
                                        style={{
                                            border: "0",
                                            borderRadius: "25px",
                                            color: "#fff",
                                            cursor: "pointer",
                                            fontWeight: "600",
                                            padding: "7px 15px 7px",
                                            backgroundColor: "#3398dc",
                                            marginRight: "15px",
                                        }}
                                    >
                                        <i className="far fa-folder-open g-mr-8"></i>Create structure from template
                                    </span>
                                </>
                            )}
                        </div>

                        <div style={{ textAlign: "right", marginTop: "30px" }}>
                            {(globalContext.userRole === "Admin" || globalContext.isMemberGuest) && (
                                <>
                                    {!globalContext.isMemberGuest && (
                                        <span
                                            onClick={() => setShowSearchExistingFilesPopup(true)}
                                            style={{
                                                border: "0",
                                                borderRadius: "25px",
                                                color: "#fff",
                                                cursor: "pointer",
                                                fontWeight: "600",
                                                padding: "7px 15px 7px",
                                                backgroundColor: "#3398dc",
                                                marginRight: "15px",
                                            }}
                                        >
                                            <i className="fas fa-search g-mr-8"></i>Add file from your MedBoard Files
                                        </span>
                                    )}
                                    <span
                                        onClick={() => showUploadNewFilesPopup()}
                                        style={{
                                            border: "0",
                                            borderRadius: "25px",
                                            color: "#fff",
                                            cursor: "pointer",
                                            fontWeight: "600",
                                            padding: "7px 15px 7px",
                                            backgroundColor: "#3398dc",
                                            marginLeft: "15px",
                                        }}
                                    >
                                        <i className="fas fa-upload g-mr-5"></i>Upload New Files
                                    </span>
                                </>
                            )}
                        </div>

                    </div>

                    {/* FILE LIST */}
                    {/* FILE LIST */}

                    {isLoadingData ? <>

                        <div style={{ width: "100%", textAlign: "center", marginTop: "30px" }}>

                            <LoadingSpinnerImage />

                        </div>

                    </> : <>
                        {attachments.length > 0 ? <>
                            <br />
                            <table className="results-table" style={{ width: "100%" }}>
                                <thead>
                                    <tr style={{ borderBottom: "1px solid #f0f0f0" }}>
                                        <th style={{ width: "65%" }}>File name</th>
                                        <th style={{ width: "10%" }}>Added By</th>
                                        <th style={{ width: "15%" }}>Date Added</th>
                                        <th style={{ width: "10%" }}>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {attachments.map((attachment, index) => (
                                        <tr key={index} style={{ borderBottom: "1px solid #f0f0f0" }}>
                                            <td>
                                                <a target="_blank" href={attachment.FileUrl} rel="noopener noreferrer">
                                                    <i className={`${getFileIcon(attachment.FileName)} g-mr-8`}></i>
                                                    {attachment.FileName}
                                                </a>
                                            </td>
                                            <td><User userId={attachment.UploadedBy} users={users} /></td>
                                            <td>{formatDate(attachment.UploadDate)}</td>


                                            <ActionDropdownCell
                                                attachment={attachment}
                                                globalContext={globalContext}
                                                openDropdownId={openDropdownId}
                                                setOpenDropdownId={setOpenDropdownId}
                                                toggleDropdown={toggleDropdown}
                                                showMovePopup={showMovePopup}
                                                showDeletePopup={showDeletePopup}
                                            />
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </> : <>
                            <div style={{ width: "100%", textAlign: "center", marginTop: "30px" }}>
                                No files yet.
                            </div>
                        </>}
                    </>}

                </div>
            </div>




            {/* UPLOAD BOX */}
            {/* UPLOAD BOX */}

            {showUploadFilesPopup && <div style={{
                position: "absolute", top: 0, bottom: 0, left: 0, right: 0, margin: "auto", width: isUploadedData == null ? "50%" : "30%",
                backgroundColor: "#fefefe", overflow: "auto", display: "flex", flexDirection: "column", borderRadius: "15px",
                padding: "15px 30px", border: "1px solid #333", maxHeight: isUploadedData == null ? "30%" : "20%", minWidth: "350px", minHeight: isUploadedData == null ? "300px" : "250px"
            }}>
                <div style={{ display: "flex", flexDirection: "row" }}>
                    <div style={{ width: "50%" }}> <h3> Upload Files</h3>
                    </div>
                    <div style={{ width: "50%", textAlign: "right" }}>
                        <button
                            className="close-button"
                            onClick={() => {
                                setshowUploadFilesPopup(false);
                            }}
                        >
                            <i className="fas fa-times"></i>
                        </button>
                    </div>
                </div>
                <div style={{ display: "flex", justifyContent: "center", width: "100%", marginTop: "20px" }}>
                    {isUploadedData === null &&
                        <div
                            {...getRootProps()}
                            style={{
                                border: `2px dashed ${isDragActive ? "#28a745" : "#ccc"}`,
                                borderRadius: "8px",
                                padding: "40px",
                                textAlign: "center",
                                transition: "0.3s ease",
                                cursor: "pointer",
                                width: "50%",
                                background: isDragActive ? "#f6fff9" : "#fff",
                            }}
                        >
                            <input {...getInputProps()} />

                            {isDragActive ? (
                                <>
                                    <i
                                        className="fas fa-check"
                                        style={{ fontSize: "32px", marginBottom: "12px", color: "#28a745" }}
                                    ></i>
                                    <p style={{ fontWeight: "600", margin: "0" }}>Drop your files here</p>
                                </>
                            ) : (
                                <>
                                    <i
                                        className="fas fa-upload"
                                        style={{ fontSize: "32px", marginBottom: "12px", color: "#6c757d" }}
                                    ></i>
                                    <p style={{ fontWeight: "600", margin: "0" }}>Drag & drop files here</p>
                                    <p style={{ fontSize: "14px", color: "#666", margin: "5px 0 0" }}>
                                        or click to select
                                    </p>
                                </>
                            )}

                            {showMaxFilesError ? <div style={{ marginTop: "15px", color: "#ff7800" }}>You can only upload 20 files at a time</div> : null}



                        </div>}
                    {isUploadedData === false && <div
                        style={{
                            padding: "10px 15px",
                            borderRadius: "6px",
                            fontSize: "14px",
                        }}
                    >
                        <LoadingSpinnerImage />
                        <span style={{ marginLeft: "10px" }}>Uploading files...</span>
                    </div>
                    }

                    {isUploadedData === true &&
                        <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                            <div
                                style={{
                                    padding: "10px 15px",
                                    background: "#d4edda",
                                    color: "#155724",
                                    border: "1px solid #c3e6cb",
                                    borderRadius: "6px",
                                    fontSize: "14px",
                                }}
                            >
                                <i className="fas fa-check-circle g-mr-8" ></i> Uploaded Files
                            </div>


                            <div style={{ marginTop: "15px", overflow: "auto", height: "100px" }}>
                                {fileUploadResults.length ? <>

                                    {fileUploadResults.map((result, index) => {
                                        return <div key={index} style={{ display: "flex", flexDirection: "row", marginBottom: "10px" }}>
                                            <div style={{ width: "80%" }}>{result.Filename}</div>
                                            <div style={{ width: "20%", textAlign: "center" }}>{result.Imported ? <span style={{ color: '#19ac19' }}>Success</span> : <span style={{ color: '#ac1919' }}>Error</span>}</div>
                                        </div>
                                    })}

                                </> : null}
                            </div>

                        </div>


                    }
                </div>
            </div>
            }



            {showSearchExistingFilesPopup &&

                <div style={{ position: "absolute", top: 0, bottom: 0, left: 0, right: 0, margin: "auto", width: "80%", backgroundColor: "#fefefe", overflow: "auto", display: "flex", flexDirection: "column", borderRadius: "15px", padding: "15px 30px", border: "1px solid #333", maxHeight: "70%" }}>


                    {/* SEARCH FOR EXISTING FILES */}
                    {/* SEARCH FOR EXISTING FILES */}

                    {!docType && (
                        <>
                            <div style={{ display: "flex", flexDirection: "row" }}>
                                <div style={{ width: "50%" }}> <h3>Search for MedBoard files uploaded</h3></div>
                                <div style={{ width: "50%", textAlign: "right" }}>
                                    <button
                                        className="close-button"
                                        onClick={() => {
                                            setShowSearchExistingFilesPopup(false);
                                            setDocType(null);
                                        }}
                                    >
                                        <i className="fas fa-times"></i>
                                    </button>
                                </div>
                            </div>

                            <h3
                                style={{ color: "#203864", marginTop: "30px", cursor: "pointer" }}
                                onClick={() => setDocType("certificates")}
                            >
                                <i style={{ fontSize: "12px" }} className="fas fa-angle-right g-mr-10"></i>
                                Certificates
                            </h3>

                            <h3
                                style={{ color: "#203864", marginTop: "30px", cursor: "pointer" }}
                                onClick={() => setDocType("submissions")}
                            >
                                <i style={{ fontSize: "12px" }} className="fas fa-angle-right g-mr-10"></i>
                                Submissions
                            </h3>

                            <h3
                                style={{ color: "#203864", marginTop: "30px", cursor: "pointer" }}
                                onClick={() => setDocType("operators")}
                            >
                                <i style={{ fontSize: "12px" }} className="fas fa-angle-right g-mr-10"></i>
                                Operators
                            </h3>
                        </>
                    )}
                    {docType && (
                        <>
                            <div style={{ display: "flex", flexDirection: "row" }}>
                                <div style={{ width: "50%" }}> <h3 style={{ color: "#203864" }}> Search for MedBoard files uploaded &nbsp; &nbsp; &gt; &nbsp; &nbsp; {docType.charAt(0).toUpperCase() + docType.slice(1)}</h3>
                                </div>
                                <div style={{ width: "50%", textAlign: "right" }}>
                                    <button
                                        className="close-button"
                                        onClick={() => {
                                            setShowSearchExistingFilesPopup(false);
                                            setDocType(null);
                                        }}
                                    >
                                        <i className="fas fa-times"></i>
                                    </button>
                                </div>
                            </div>
                            <CountryRegistrationsDocuments
                                embedInSubmissions={true}
                                actionMethodForSubmissions={callBackFromCountryRegistrationsDocuments}
                                hideTitle={true}
                                hideBreadcrumbs={true}
                                allSubmissionFilesIds={allSubmissionFilesIds}
                                filterDocType={docType}
                            />
                        </>
                    )}
                </div>

            }






            {/* DELETE POPUP */}
            {/* DELETE POPUP */}

            {showUnlinkAttachmentPopup &&

                <div style={{ position: "fixed", top: "0px", left: "0px", width: "100%", height: "100%", backgroundColor: "#000000aa", zIndex: 10 }}>

                    <div style={{ position: "absolute", paddingTop: "10px", borderRadius: "15px", width: "350px", height: "130px", border: "1px solid #343434", backgroundColor: "#fafafa", top: "20%", left: "calc(50% - 175px)", textAlign: "center" }}>

                        Are you sure you want to remove this file from the submission?

                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-around", marginTop: "25px" }}>

                            <div>
                                <div onClick={() => setShowUnlinkAttachmentPopup(false)} className="action-button cancel-button"> Cancel </div>
                            </div>

                            <div>
                                {isLoadingData ? <>
                                    <LoadingSpinnerImage />
                                </> : <>
                                    <div onClick={() => unlinkAttachment()} className="action-button delete-button"> Yes, Remove </div>
                                </>}
                            </div>
                        </div>
                    </div>

                </div>
            }




            {/* MOVE POPUP */}
            {/* MOVE POPUP */}

            {showMoveAttachmentPopup &&

                <div style={{ position: "fixed", top: "0px", left: "0px", width: "100%", height: "100%", backgroundColor: "#000000aa", zIndex: 10 }}>

                    <div style={{ position: "absolute", paddingTop: "10px", borderRadius: "15px", width: "500px", height: "150px", border: "1px solid #343434", backgroundColor: "#fafafa", top: "20%", left: "calc(50% - 175px)", textAlign: "center" }}>

                        Move this file to a new folder

                        <div>
                            {drawGroupsDropdown()}
                        </div>

                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-around", marginTop: "25px" }}>

                            <div>
                                <div onClick={() => setShowMoveAttachmentPopup(false)} className="action-button cancel-button"> Cancel </div>
                            </div>

                            <div>
                                {isMovingFile ?
                                    <div><LoadingSpinnerImage /></div>
                                    :
                                    <div onClick={() => moveAttachment()} className="action-button delete-button"> Move </div>
                                }
                            </div>
                        </div>
                    </div>

                </div>
            }



            {/* CREATE STRUCTURE FROM TEMPLATE */}
            {/* CREATE STRUCTURE FROM TEMPLATE */}

            {showCreateStructureFromTemplatePopup && (
                <div
                    style={{
                        position: "fixed",
                        inset: 0,
                        backgroundColor: "rgba(0, 0, 0, 0.65)",
                        zIndex: 10,
                        display: "flex",
                        alignItems: "flex-start",
                        justifyContent: "center",
                        paddingTop: "10vh",
                        overflowY: "auto",
                    }}
                >
                    <div
                        style={{
                            width: "500px",
                            maxWidth: "calc(100% - 40px)",
                            borderRadius: "12px",
                            border: "1px solid #d0d0d0",
                            backgroundColor: "#fafafa",
                            boxShadow: "0 8px 30px rgba(0, 0, 0, 0.25)",
                            overflow: "hidden",
                        }}
                    >
                        {/* Header */}
                        <div
                            style={{
                                padding: "18px 24px",
                                borderBottom: "1px solid #e0e0e0",
                            }}
                        >


                            <div style={{ display: "flex", flexDirection: "row" }} >
                                <div style={{ flex: "1 1 0%" }} ><h3>Create document structure from template</h3></div>
                                <div style={{ textAlign: "right" }}><button className="close-button" onClick={() => setShowCreateStructureFromTemplatePopup(false)}><i className="fas fa-times"></i></button></div>
                            </div>

                        </div>

                        {/* Content */}
                        <div
                            style={{
                                padding: "25px 24px",
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "8px",
                                }}
                            >
                                <label
                                    style={{
                                        fontSize: "14px",
                                        fontWeight: "500",
                                        color: "#555",
                                    }}
                                >
                                    Template
                                </label>

                                <select
                                    value={selectedTemplate}
                                    onChange={(e) => setSelectedTemplate(e.target.value)}
                                    style={{
                                        width: "100%",
                                        padding: "9px 10px",
                                        border: "1px solid #ccc",
                                        borderRadius: "5px",
                                        backgroundColor: "#fff",
                                        fontSize: "14px",
                                    }}
                                >
                                    <option value="">Select a template</option>
                                    <option value="EUMDR">EU MDR</option>
                                    <option value="510k">FDA 510(k)</option>
                                    <option value="IMDRF">nIVD ToC (IMDRF)</option>
                                    <option value="STED">STED (GHTF)</option>
                                    <option value="CSTD">CSTD (ASEAN)</option>
                                </select>
                            </div>

                            {/* Error */}
                            {errorCreatingStructureFromTemplate && (
                                <div
                                    style={{
                                        marginTop: "20px",
                                        padding: "12px 14px",
                                        border: "1px solid #f5c2c7",
                                        borderRadius: "6px",
                                        backgroundColor: "#f8d7da",
                                        color: "#842029",
                                        fontSize: "14px",
                                        lineHeight: "1.4",
                                    }}
                                >
                                    <div
                                        style={{
                                            fontWeight: "600",
                                            marginBottom: "4px",
                                        }}
                                    >
                                        Unable to create folder structure
                                    </div>

                                    <div>
                                        {errorCreatingStructureFromTemplate}
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Footer */}
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                gap: "10px",
                                padding: "15px 24px",
                                borderTop: "1px solid #e0e0e0",
                                backgroundColor: "#f5f5f5",
                            }}
                        >
                            <div
                                onClick={() => setShowCreateStructureFromTemplatePopup(false)}
                                className="action-button cancel-button"
                            >
                                Cancel
                            </div>

                            {isCreatingStructureFromTemplate ? (
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        minWidth: "120px",
                                    }}
                                >
                                    <LoadingSpinnerImage />
                                </div>
                            ) : (
                                <div
                                    onClick={() => createStructureFromTemplate()}
                                    className="action-button save-button"
                                    style={{
                                        opacity: selectedTemplate === "" ? 0.5 : 1,
                                        cursor: selectedTemplate === ""
                                            ? "not-allowed"
                                            : "pointer",
                                    }}
                                >
                                    Create structure
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}





            {showEditGroupPopup && <EditGroupPopup
                groups={groups}
                setGroups={setGroups}
                isEditingGroupId={isEditingGroupId}
                setSelectedParentGroupId={setSelectedParentGroupId}
                selectedParentGroupId={selectedParentGroupId}
                setShowEditGroupPopup={setShowEditGroupPopup}
                drawGroupsDropdown={drawGroupsDropdown}
                submissionId={submissionId}
            />}


            {showCreateGroupPopup && <CreateGroupPopup
                groups={groups}
                setGroups={setGroups}
                selectedParentGroupIdFromContextMenu={selectedParentGroupIdFromContextMenu}
                selectedParentGroupId={selectedParentGroupId}
                setShowCreateGroupPopup={setShowCreateGroupPopup}
                drawGroupsDropdown={drawGroupsDropdown}
                submissionId={submissionId}
            />}



        </>
    );


}


const User = ({ userId, users, size = "" }) => {

    const getUserById = (id) => {
        return users.find((item) => item.Id == id);
    };

    let user = getUserById(userId);

    return (
        <>
            {
                user ? (
                    <div
                        className={
                            "user-initials-circle " +
                            (size == "small" ? "user-initials-circle-small" : "")
                        }
                        style={{ backgroundColor: user?.IsItMe ? "#0176b9" : "#e7e7e7", color: user?.IsItMe ? "white" : "black" }}
                        title={user?.Name}
                    >
                        {user?.Initials}
                    </div>
                ) : null}
        </>
    );
};






const GroupsMenu = ({ groups, setGroups, isFoldersContextMenuVisible, setIsFoldersContextMenuVisible, setSelectedParentGroupId, closeGroupRelatedPopups, setShowCreateGroupPopup, setIsEditingGroupId, setShowEditGroupPopup, selectedMainMenuOption, currentGroupId, navigateTo, userRole, folderContextMenuIconRefs, folderContextMenuRef, allFilesCount, setAllFilesCount, isMemberGuest
}) => {

    const [showGroupMenu, setShowGroupMenu] = useState(null);
    const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
    const [selectedItemId, setSelectedItemId] = useState(null);


    const expandItem = (id) => {

        let newGroups = groups.map(item => item.Id == id ? { ...item, Expanded: true } : item);
        setGroups(newGroups);
    }

    const collapseItem = (id) => {

        let newGroups = groups.map(item => item.Id == id ? { ...item, Expanded: false } : item);
        setGroups(newGroups);
    }


    const handleIconClick = (event, itemId) => {
        // Prevent the default behavior of the event
        event.preventDefault();
        event.stopPropagation();

        // Get the position of the clicked icon
        const rect = event.target.getBoundingClientRect();

        // Set the position of the contextual menu
        setMenuPosition({
            top: rect.bottom + window.scrollY,
            left: rect.left + window.scrollX,
        });


        // Set the selected item ID
        setSelectedItemId(itemId);

        // Show the contextual menu
        setIsFoldersContextMenuVisible(true);
    };

    const handleMenuClose = () => {
        setIsFoldersContextMenuVisible(false);
    };

    const handleAdd = () => {
        setSelectedParentGroupId(selectedItemId);
        closeGroupRelatedPopups();
        setShowCreateGroupPopup(true);

        handleMenuClose();
    };

    const handleEdit = () => {
        closeGroupRelatedPopups();
        setIsEditingGroupId(selectedItemId);
        setShowEditGroupPopup(true);

        handleMenuClose();
    };



    const drawGroupsMenuOptions = (parentId, level) => {


        let groupOptions = groups.filter(group => group.ParentId == parentId).sort((a, b) => a.Name.localeCompare(b.Name, undefined, { sensitivity: 'base' }));


        if (groupOptions.length == 0)
            return;


        let indentation = level == 0 ? "0px" : "15px";

        return (

            <>

                {
                    groupOptions.map((item, index) => {

                        let isEditingOrRemoving = false;

                        return (

                            <div key={index} style={{ paddingLeft: indentation }}>

                                <div className={`reference-manager-menu-option-group ${selectedMainMenuOption == "group" && currentGroupId == item.Id ? "selected-main-menu-option-group" : ""}`} style={{

                                    display: "flex",
                                    flexDirection: "column",
                                    border: isEditingOrRemoving ? "1px solid #eeeeee" : "none",
                                    backgroundColor: isEditingOrRemoving ? "#f4f5f7" : "",
                                    color: isEditingOrRemoving ? "#555" : "",
                                    padding: isEditingOrRemoving ? "9px" : "",
                                    borderRadius: isEditingOrRemoving ? "10px" : "",

                                }}
                                    onMouseEnter={() => setShowGroupMenu(item.Id)}
                                    onMouseLeave={() => setShowGroupMenu(null)}
                                >


                                    <div style={{ display: "flex", flexDirection: "row" }}>

                                        <div style={{ width: "80%", textAlign: "left" }} >

                                            <div className="pointer" onClick={() => { expandItem(item.Id); navigateTo({ menu: "group", groupId: item.Id }); }}>
                                                {(() => {

                                                    let hasChildren = groups.find(child => child.ParentId == item.Id);

                                                    return (<><i className={item.Expanded && hasChildren ? "fas fa-folder-open" : "far fa-folder"} style={{ height: "14px", width: "13px", marginRight: "5px", color: "#a09d9d" }}></i> {item.Name} <span style={{ color: "#a09d9d" }}>({item.Count})</span></>);

                                                })()}

                                            </div>

                                        </div>

                                        <div style={{ width: "10%", textAlign: "center" }}>

                                            {(showGroupMenu === item.Id && userRole == "Admin") ? <>
                                                <span
                                                    className="pointer" style={{ padding: "0px 8px" }}

                                                    ref={(el) => {
                                                        if (el) {
                                                            // Add the element to iconRefs.current if it's not null
                                                            folderContextMenuIconRefs.current[item.id] = el;
                                                        } else {
                                                            // Remove the element from iconRefs.current if it's null (unmounting)
                                                            delete folderContextMenuIconRefs.current[item.id];
                                                        }
                                                    }}

                                                    onClick={(e) => {
                                                        handleIconClick(e, item.Id);

                                                    }}>
                                                    <i title="Options" className="fas fa-ellipsis-v"></i>
                                                </span>
                                            </> : null}

                                        </div>

                                        <div style={{ width: "10%", textAlign: "center" }}>

                                            {/* Does it have children? Show expansion arrow */}
                                            {groups.find(child => child.ParentId == item.Id) ? <>

                                                {item.Expanded ? <>
                                                    <span style={{ cursor: "pointer" }} onClick={() => collapseItem(item.Id)}>
                                                        <i className="fas fa-angle-down" style={{ color: "#8e8e8e" }}></i>
                                                    </span>
                                                </> : <>
                                                    <span style={{ cursor: "pointer" }} onClick={() => expandItem(item.Id)}>
                                                        <i className="fas fa-angle-right" style={{ color: "#8e8e8e" }}></i>
                                                    </span>
                                                </>}

                                            </> : null}

                                        </div>


                                    </div>


                                </div>

                                {item.Expanded ? drawGroupsMenuOptions(item.Id, level + 1) : null}

                            </div>


                        )
                    }
                    )
                }

            </>


        );

    }



    return (<div className="thin-scrollbar" style={{ overflow: "auto" }}>



        <div className={`${currentGroupId == null ? "selected-main-menu-option-group" : ""}`} style={{ display: "flex", flexDirection: "row", paddingLeft: "10px", cursor: "pointer", height: "25px", alignItems: "center", marginBottom: "5px" }} onClick={() => { navigateTo({ menu: "group", groupId: null }); }}>
            <div className="pointer">All files <span style={{ color: "#a09d9d" }}>({allFilesCount ?? 0})</span></div>
            <div>

                <div className="reference-manager-menu-option-new-group" style={{ marginBottom: "0px" }}>
                    {(userRole === "Admin" || isMemberGuest) && (
                        <div className="pointer" title="Add a new folder" onClick={(e) => {
                            e.stopPropagation();
                            setSelectedParentGroupId(currentGroupId);
                            closeGroupRelatedPopups();
                            setShowCreateGroupPopup(true);
                        }}>
                            <span alt="Add a new folder" style={{ padding: "0px 2px", borderRadius: "15px", backgroundColor: "#f6fcff" }}>
                                <i className="fas fa-plus-circle" style={{ color: "#3da5f7" }}></i>
                            </span>
                        </div>
                    )}

                </div>

            </div>
        </div>








        {drawGroupsMenuOptions(null, 0)}


        {isFoldersContextMenuVisible && (
            <div
                ref={folderContextMenuRef}
                style={{
                    position: 'fixed',
                    top: menuPosition.top,
                    left: menuPosition.left,
                    backgroundColor: 'white',
                    border: '1px solid #ccc',
                    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                    zIndex: 1000,
                    borderRadius: "5px",
                    overflow: "hidden",
                }}
            >
                <div
                    className="folder-context-menu-option"
                    style={{ display: "flex", flexDirection: "row", padding: '5px 10px', cursor: 'pointer' }}
                    onClick={handleAdd}
                >
                    <div><i className="fas fa-plus-circle" style={{ color: "#969696", marginRight: "5px" }}></i></div>
                    <div>Add sub-folder</div>
                </div>
                <div
                    className="folder-context-menu-option"
                    style={{ display: "flex", flexDirection: "row", padding: '5px 10px', cursor: 'pointer' }}
                    onClick={handleEdit}
                >
                    <div><i className="fas fa-pencil-alt" style={{ color: "#969696", marginRight: "5px" }}></i></div>
                    <div>Edit folder</div>
                </div>
            </div>
        )}

    </div>)




}








const EditGroupPopup = ({ groups, setGroups, isEditingGroupId, setSelectedParentGroupId, selectedParentGroupId, setShowEditGroupPopup, drawGroupsDropdown, submissionId }) => {



    const [groupName, setGroupName] = useState("");
    const [groupParentId, setGroupParentId] = useState("");
    const [showErrorEditingGroup, setShowErrorEditingGroup] = useState(false);
    const [isEditingGroup, setIsEditingGroup] = useState(false);
    const [showErrorRemovingGroup, setShowErrorRemovingGroup] = useState(false);
    const [isRemovingGroup, setIsRemovingGroup] = useState(false);
    const [showRemoveConfirmation, setShowRemoveConfirmation] = useState(false);
    const [customErrorMessage, setCustomErrorMessage] = useState(null);


    let group = groups.find(group => group.Id == isEditingGroupId);


    const clearLoadingsAndErrors = () => {
        setIsEditingGroup(false);
        setShowErrorEditingGroup(false);
        setIsRemovingGroup(false);
        setShowErrorRemovingGroup(false);
        setShowRemoveConfirmation(false);
        setCustomErrorMessage(null);
    }


    useEffect(() => {
        clearLoadingsAndErrors();
        setGroupName(group.Name);
        setGroupParentId(group.ParentId);
        setSelectedParentGroupId("" + group.ParentId);

    }, [group])


    /*
     * Edit a custom group
     */

    const editGroup = (id) => {

        let newName = groupName;

        let parentGroupId = null;

        if (!isNaN(selectedParentGroupId))
            parentGroupId = parseInt(selectedParentGroupId);

        let editGroupURL = "/umbraco/api/Submission/Folders/?submissionId=" + submissionId + "&folderId=" + id + "&name=" + newName + "&parentId=" + parentGroupId;

        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
        };

        clearErrors();
        setIsEditingGroup(true);


        fetch(editGroupURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    setShowErrorEditingGroup(true);
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                if (data.Id) {
                    // Create a new array with the edited item
                    const newGroups = groups.map((item) => item.Id === id ? { ...item, Name: data.Name, ParentId: data.ParentId } : item);

                    // Update the state with the new array
                    setGroups(newGroups);
                    setShowEditGroupPopup(false);
                }
                else {
                    setShowErrorEditingGroup(true);

                    if (data == -1)
                        setCustomErrorMessage("Can't set the parent folder to a child of its own");
                }
            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsEditingGroup(false);
            });






    };



    const clearErrors = () => {

        setShowErrorRemovingGroup(false);
        setShowErrorEditingGroup(false);

    }




    /*
     * Remove a custom group
     */

    const removeGroup = (id) => {

        let group = groups.find(g => g.Id == id);

        let removeGroupURL = "/umbraco/api/Submission/Folders/?submissionId=" + encodeURIComponent(submissionId) + "&folderId=" + encodeURIComponent(id);

        const requestOptions = {
            method: "DELETE",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(group)
        };

        clearErrors();
        setIsRemovingGroup(true);
        setCustomErrorMessage(null);


        fetch(removeGroupURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    setShowErrorRemovingGroup(true);
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {

                if (data == true) {
                    const newGroups = groups.filter((item) => item.Id !== id);
                    setGroups(newGroups);
                    setShowEditGroupPopup(false);
                }
                else {
                    setShowErrorRemovingGroup(true);

                    if (data == -1)
                        setCustomErrorMessage("Cannot remove folder that has sub-folders");
                }
            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                setShowErrorRemovingGroup(true);
                console.log("error: " + error);
            })
            .finally(() => {
                setIsRemovingGroup(false);
            });



    }







    return (
        <div className="add-task-popup" style={{ width: "500px" }}>
            <div style={{ display: "flex", flexDirection: "row", marginBottom: "5px" }}>


                <div style={{ flex: 1 }}>
                    <h3>Editing folder `{group.Name}`</h3>
                </div>
                <div style={{ textAlign: "right" }}>
                    <button
                        className="close-button"
                        onClick={() => { setShowEditGroupPopup(false); }}
                    >
                        <i className="fas fa-times"></i>
                    </button>
                </div>

            </div>

            <div style={{ textAlign: "left", marginTop: "25px", marginBottom: "25px" }}>

                <div>Parent folder:</div>
                <div>
                    {drawGroupsDropdown({ ignoreIds: [group.Id] })}
                </div>
                <div style={{ marginTop: "15px" }}>
                    Folder name:
                    <br />
                    <input type="text" style={{ width: "100%" }} value={groupName} onChange={(e) => setGroupName(e.target.value)} />
                </div>

                {(showErrorEditingGroup || showErrorRemovingGroup) &&
                    <div style={{ marginTop: "15px" }}>
                        An error occurred
                        {customErrorMessage != null ? <div>{customErrorMessage}</div> : null}
                    </div>
                }

                <div style={{ marginTop: "15px", display: "flex", flexDirection: "row" }}>
                    <div style={{ flex: 1, justifyContent: "start", display: "flex" }}>
                        {!isEditingGroup ?
                            <button onClick={() => editGroup(group.Id)} className="action-button save-button">Save</button>
                            : <LoadingSpinnerImage />
                        }
                    </div>
                    <div style={{ flex: 1, justifyContent: "end", display: "flex" }}>

                        {showRemoveConfirmation ? <>
                            {!isRemovingGroup ?
                                <button onClick={() => removeGroup(group.Id)} className="action-button delete-button">Yes, delete</button>
                                : <LoadingSpinnerImage />
                            }
                        </> : <>
                            <button onClick={() => setShowRemoveConfirmation(true)} className="action-button delete-button">Delete</button>
                        </>}

                    </div>
                </div>

            </div>

        </div>
    );
}






const CreateGroupPopup = ({ groups, setGroups, selectedParentGroupIdFromContextMenu, selectedParentGroupId, setShowCreateGroupPopup, drawGroupsDropdown, submissionId }) => {


    const [groupName, setGroupName] = useState("");
    const [groupParentId, setGroupParentId] = useState(null);
    const [showErrorCreatingGroup, setShowErrorCreatingGroup] = useState(false);
    const [isCreatingGroup, setIsCreatingGroup] = useState(false);


    /*
     * Create a custom group
     */

    const createGroup = () => {

        let editGroupURL = "/umbraco/api/Submission/Folders/?submissionId=" + submissionId + "&folderName=" + groupName + "&parentId=" + selectedParentGroupId;

        //if (selectedParentGroupIdFromContextMenu) {
        //    parentGroupId = parseInt(selectedParentGroupIdFromContextMenu);
        //}
        //else
        //    if (!isNaN(selectedParentGroupId))
        //        parentGroupId = parseInt(selectedParentGroupId);


        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
        };

        setShowErrorCreatingGroup(false);
        setIsCreatingGroup(true);


        fetch(editGroupURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    setShowErrorCreatingGroup(true);
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                if (data.Id) {
                    // Update the state with the new array
                    setGroups([...groups, data]);
                    setIsCreatingGroup(false);
                    setShowCreateGroupPopup(false);
                }
                else {
                    setShowErrorCreatingGroup(true);
                }
            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsCreatingGroup(false);
            });






    };




    return (
        <div className="add-task-popup" style={{ width: "500px" }}>
            <div style={{ display: "flex", flexDirection: "row", marginBottom: "5px" }}>


                <div style={{ flex: 1 }}>
                    <h3>Add a new folder</h3>
                </div>
                <div style={{ textAlign: "right" }}>
                    <button
                        className="close-button"
                        onClick={() => { setShowCreateGroupPopup(false); }}
                    >
                        <i className="fas fa-times"></i>
                    </button>
                </div>

            </div>

            <div style={{ textAlign: "left", marginTop: "25px", marginBottom: "25px" }}>

                <div>Parent folder:</div>
                <div>
                    {drawGroupsDropdown()}
                </div>
                <div style={{ marginTop: "15px" }}>
                    Folder name:
                    <br />
                    <input type="text" style={{ width: "100%" }} value={groupName} onChange={(e) => setGroupName(e.target.value)} />
                </div>

                {showErrorCreatingGroup &&
                    <div style={{ marginTop: "15px" }}>
                        An unexpected error occurred
                    </div>
                }

                <div style={{ marginTop: "15px" }}>
                    {!isCreatingGroup ?
                        <button onClick={() => createGroup()} className="action-button save-button">Save</button>
                        : <LoadingSpinnerImage />
                    }
                </div>

            </div>

        </div>
    );
}






const ActionDropdownCell = ({
    attachment,
    globalContext,
    openDropdownId,
    setOpenDropdownId,
    toggleDropdown,
    showMovePopup,
    showDeletePopup
}) => {
    const cellRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (openDropdownId === attachment.CertificateFileId &&
                cellRef.current &&
                !cellRef.current.contains(event.target)) {
                setOpenDropdownId(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [openDropdownId, attachment.CertificateFileId, setOpenDropdownId]);

    return (
        <td ref={cellRef} style={{ position: "relative" }}>
            {/* Trigger Button (Vertical Three Dots) */}
            <span
                title="More options"
                onClick={() => toggleDropdown(attachment.CertificateFileId)}
                style={{ cursor: "pointer", padding: "4px 8px" }}
            >
                <i className="fas fa-ellipsis-v"></i>
            </span>

            {/* Dropdown Menu */}
            {openDropdownId === attachment.CertificateFileId && (
                <div style={{
                    position: "absolute",
                    right: "0",
                    top: "100%",
                    backgroundColor: 'white',
                    border: '1px solid #ccc',
                    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                    zIndex: 1000,
                    borderRadius: "5px",
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column",
                    minWidth: "160px"
                }}>
                    {/* Download Option */}
                    <a
                        target="_blank"
                        href={attachment.FileUrl}
                        rel="noopener noreferrer"
                        className="submissions-dropdown-item"
                        style={{ textDecoration: "none" }}
                    >
                        <i className="fas fa-file-download" style={{ marginRight: "10px", width: "16px" }}></i> Download
                    </a>

                    {/* Conditional Admin/Owner Options */}
                    {((globalContext.isMemberGuest && attachment.UploadedBy != globalContext.currentUserId) || (globalContext.userRole !== "Admin")) ? null : (
                        <>
                            <span
                                onClick={() => {
                                    showMovePopup(attachment.CertificateFileId);
                                    setOpenDropdownId(null);
                                }}
                                className="submissions-dropdown-item"
                                style={{ cursor: "pointer" }}
                            >
                                <i className="far fa-folder" style={{ marginRight: "10px", width: "16px" }}></i> Move to folder
                            </span>

                            <span
                                onClick={() => {
                                    showDeletePopup(attachment.CertificateFileId);
                                    setOpenDropdownId(null);
                                }}
                                className="submissions-dropdown-item"
                                style={{ cursor: "pointer" }}
                            >
                                <i className="fas fa-times-circle" style={{ marginRight: "10px", width: "16px" }}></i> Remove
                            </span>
                        </>
                    )}
                </div>
            )}
        </td>
    );
};


export default SubmissionAttachments;